import { render, staticRenderFns } from "./following.vue?vue&type=template&id=b4f2046e&lang=pug"
import script from "./following.vue?vue&type=script&lang=js"
export * from "./following.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports